var map = {
	"./de-DE/actionLogs.json": [
		"./src/locales/de-DE/actionLogs.json",
		"vendors~main.vision2"
	],
	"./de-DE/dashboard.json": [
		"./src/locales/de-DE/dashboard.json",
		"vendors~main.vision2"
	],
	"./de-DE/individualRiskProfile.json": [
		"./src/locales/de-DE/individualRiskProfile.json",
		"vendors~main.vision2"
	],
	"./de-DE/riskAnalysis.json": [
		"./src/locales/de-DE/riskAnalysis.json",
		"vendors~main.vision2"
	],
	"./de-DE/translation.json": [
		"./src/locales/de-DE/translation.json",
		"vendors~main.vision2"
	],
	"./de-DE/watchlists.json": [
		"./src/locales/de-DE/watchlists.json",
		"vendors~main.vision2"
	],
	"./en-GB/actionLogs.json": [
		"./src/locales/en-GB/actionLogs.json",
		"vendors~main.vision2"
	],
	"./en-GB/dashboard.json": [
		"./src/locales/en-GB/dashboard.json",
		"vendors~main.vision2"
	],
	"./en-GB/individualRiskProfile.json": [
		"./src/locales/en-GB/individualRiskProfile.json",
		"vendors~main.vision2"
	],
	"./en-GB/riskAnalysis.json": [
		"./src/locales/en-GB/riskAnalysis.json",
		"vendors~main.vision2"
	],
	"./en-GB/translation.json": [
		"./src/locales/en-GB/translation.json",
		"vendors~main.vision2"
	],
	"./en-GB/watchlists.json": [
		"./src/locales/en-GB/watchlists.json",
		"vendors~main.vision2"
	],
	"./en-US/actionLogs.json": [
		"./src/locales/en-US/actionLogs.json",
		"vendors~main.vision2"
	],
	"./en-US/dashboard.json": [
		"./src/locales/en-US/dashboard.json",
		"vendors~main.vision2"
	],
	"./en-US/individualRiskProfile.json": [
		"./src/locales/en-US/individualRiskProfile.json",
		"vendors~main.vision2"
	],
	"./en-US/riskAnalysis.json": [
		"./src/locales/en-US/riskAnalysis.json",
		"vendors~main.vision2"
	],
	"./en-US/translation.json": [
		"./src/locales/en-US/translation.json",
		"vendors~main.vision2"
	],
	"./en-US/watchlists.json": [
		"./src/locales/en-US/watchlists.json",
		"vendors~main.vision2"
	],
	"./es-ES/actionLogs.json": [
		"./src/locales/es-ES/actionLogs.json",
		"vendors~main.vision2"
	],
	"./es-ES/dashboard.json": [
		"./src/locales/es-ES/dashboard.json",
		"vendors~main.vision2"
	],
	"./es-ES/individualRiskProfile.json": [
		"./src/locales/es-ES/individualRiskProfile.json",
		"vendors~main.vision2"
	],
	"./es-ES/riskAnalysis.json": [
		"./src/locales/es-ES/riskAnalysis.json",
		"vendors~main.vision2"
	],
	"./es-ES/translation.json": [
		"./src/locales/es-ES/translation.json",
		"vendors~main.vision2"
	],
	"./es-ES/watchlists.json": [
		"./src/locales/es-ES/watchlists.json",
		"vendors~main.vision2"
	],
	"./fr-CA/actionLogs.json": [
		"./src/locales/fr-CA/actionLogs.json",
		"vendors~main.vision2"
	],
	"./fr-CA/dashboard.json": [
		"./src/locales/fr-CA/dashboard.json",
		"vendors~main.vision2"
	],
	"./fr-CA/individualRiskProfile.json": [
		"./src/locales/fr-CA/individualRiskProfile.json",
		"vendors~main.vision2"
	],
	"./fr-CA/riskAnalysis.json": [
		"./src/locales/fr-CA/riskAnalysis.json",
		"vendors~main.vision2"
	],
	"./fr-CA/translation.json": [
		"./src/locales/fr-CA/translation.json",
		"vendors~main.vision2"
	],
	"./fr-CA/watchlists.json": [
		"./src/locales/fr-CA/watchlists.json",
		"vendors~main.vision2"
	],
	"./fr-FR/actionLogs.json": [
		"./src/locales/fr-FR/actionLogs.json",
		"vendors~main.vision2"
	],
	"./fr-FR/dashboard.json": [
		"./src/locales/fr-FR/dashboard.json",
		"vendors~main.vision2"
	],
	"./fr-FR/individualRiskProfile.json": [
		"./src/locales/fr-FR/individualRiskProfile.json",
		"vendors~main.vision2"
	],
	"./fr-FR/riskAnalysis.json": [
		"./src/locales/fr-FR/riskAnalysis.json",
		"vendors~main.vision2"
	],
	"./fr-FR/translation.json": [
		"./src/locales/fr-FR/translation.json",
		"vendors~main.vision2"
	],
	"./fr-FR/watchlists.json": [
		"./src/locales/fr-FR/watchlists.json",
		"vendors~main.vision2"
	],
	"./it-IT/actionLogs.json": [
		"./src/locales/it-IT/actionLogs.json",
		"vendors~main.vision2"
	],
	"./it-IT/dashboard.json": [
		"./src/locales/it-IT/dashboard.json",
		"vendors~main.vision2"
	],
	"./it-IT/individualRiskProfile.json": [
		"./src/locales/it-IT/individualRiskProfile.json",
		"vendors~main.vision2"
	],
	"./it-IT/riskAnalysis.json": [
		"./src/locales/it-IT/riskAnalysis.json",
		"vendors~main.vision2"
	],
	"./it-IT/translation.json": [
		"./src/locales/it-IT/translation.json",
		"vendors~main.vision2"
	],
	"./it-IT/watchlists.json": [
		"./src/locales/it-IT/watchlists.json",
		"vendors~main.vision2"
	],
	"./nl-NL/actionLogs.json": [
		"./src/locales/nl-NL/actionLogs.json",
		"vendors~main.vision2"
	],
	"./nl-NL/dashboard.json": [
		"./src/locales/nl-NL/dashboard.json",
		"vendors~main.vision2"
	],
	"./nl-NL/individualRiskProfile.json": [
		"./src/locales/nl-NL/individualRiskProfile.json",
		"vendors~main.vision2"
	],
	"./nl-NL/riskAnalysis.json": [
		"./src/locales/nl-NL/riskAnalysis.json",
		"vendors~main.vision2"
	],
	"./nl-NL/translation.json": [
		"./src/locales/nl-NL/translation.json",
		"vendors~main.vision2"
	],
	"./nl-NL/watchlists.json": [
		"./src/locales/nl-NL/watchlists.json",
		"vendors~main.vision2"
	],
	"./pt-PT/actionLogs.json": [
		"./src/locales/pt-PT/actionLogs.json",
		"vendors~main.vision2"
	],
	"./pt-PT/dashboard.json": [
		"./src/locales/pt-PT/dashboard.json",
		"vendors~main.vision2"
	],
	"./pt-PT/individualRiskProfile.json": [
		"./src/locales/pt-PT/individualRiskProfile.json",
		"vendors~main.vision2"
	],
	"./pt-PT/riskAnalysis.json": [
		"./src/locales/pt-PT/riskAnalysis.json",
		"vendors~main.vision2"
	],
	"./pt-PT/translation.json": [
		"./src/locales/pt-PT/translation.json",
		"vendors~main.vision2"
	],
	"./pt-PT/watchlists.json": [
		"./src/locales/pt-PT/watchlists.json",
		"vendors~main.vision2"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/locales lazy recursive ^\\.\\/.*\\/.*\\.json$";
module.exports = webpackAsyncContext;